<template>
  <div style="width: 55vw; height: 49vh; margin-left: 4vw; margin-top: 5vh;">

    <svg ref="svg" width="100%" height="100%" viewBox="0 0 1000 500" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="999" height="499" rx="3.5" stroke="#D3D3D3"/>
      <g v-for="sub in subPlacement" :key="sub.id">
        <rect :x="sub.x" :y="sub.y" width="63" height="63" rx="5.5" :fill="`url(#paint${sub.id}_linear_10409_44419)`" stroke="#2DE5FE"/>
        <text :x="sub.x + 63/2" :y="sub.y + 63/2 + 18/3" style="font-family: Sora;
          font-style: light;
          font-size  : 18px;
          stroke     : white;
          fill       : white;
          text-anchor: middle;
          cursor: pointer"
        >{{ sub.label }}
        </text>
        <g v-if="withScales">
          <g v-for="line in lines" :key="line.id">
            <line  
              :x1="line.x1" 
              :y1="line.y1" 
              :x2="line.x2" 
              :y2="line.y2" 
              class="line-design" 
              stroke="#2DE5FE" 
              stroke-width=".5" 
              stroke-dasharray="3.5"
            >
            </line>

            <text 
              :x="(line.x1 + line.x2) / 2 + (line.direction === 'vertical' ? textXOffset : 0)" 
              :y="((line.y1 + line.y2) / 2) + (line.direction === 'horizontal' ? textYOffset : 0)" 
              style="font-family: Sora;
                font-style: light;
                font-size  : 18px;
                fill       : white;
                text-anchor: middle;
                cursor: pointer"
            >
            </text>

          </g>
          
          <g v-for="line in arrows" :key="line.id">
            <line  
              :x1="line.x1" 
              :y1="line.y1" 
              :x2="line.x2" 
              :y2="line.y2" 
              class="line-design" 
              stroke="#2DE5FE" 
              stroke-width="1" 
              stroke-linecap="5,5"
              marker-start="url(#arrowhead-start)" 
              marker-end="url(#arrowhead-end)"
            >
            </line>

            <text 
              :x="(line.x1 + line.x2) / 2 + (line.direction === 'vertical' ? textXOffset : 0)" 
              :y="((line.y1 + line.y2) / 2) + (line.direction === 'horizontal' ? textYOffset : 0)" 
              :style="getTextStyle(line)"
            >{{ renderDistance(line.lineLength) }} {{ unit === "feet" ? '(ft)' : '(cm)' }}
            </text>

          </g>
        </g>
      </g>
      
      <defs>
        <linearGradient 
          v-for="sub in subPlacement" 
          :key="sub.id + '_gradient'"
          :id="'paint' + sub.id + '_linear_10409_44419'"
          :x1="sub.x + 32" :y1="sub.y" :x2="sub.x + 32" :y2="sub.y + 44" gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2B313B"/>
          <stop offset="1" stop-color="#13161B"/>
        </linearGradient>

        <marker 
          id="arrowhead-end" 
          markerWidth="10" 
          markerHeight="7"
          class="line-design"
          refX="10" 
          refY="3.5" 
          orient="auto"
        >
          <polygon 
            class="arrow-design"
            points="0 0, 10 3.5, 0 7" 
            fill="#2DE5FE"
          />
        </marker>
        
        <marker 
          id="arrowhead-start" 
          markerWidth="10" 
          markerHeight="7" 
          class="line-design" 
          refX="0" 
          refY="3.5" 
          orient="auto"
        >
          <polygon
            class="arrow-design"
            points="10 0, 0 3.5, 10 7" 
            fill="#2DE5FE"
          />
        </marker>
      </defs>

    </svg>
  </div>
</template>

<script>
export default {
  name: "CSubVisualisation",
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  props: {
    idx: Number,
    withScales: Boolean,
    currentWidth: Number,
    currentHeight: Number,
    RoomInstance: Object,
    unit: String
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  data () {
    return {
      subSize: 63,
      subPlacement: [],
      lines: [],
      arrows: [],
      textYOffset: 20,
      textXOffset: 10,
      feetConst: 0.0328084
    }
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  mounted: function() {
    let svgSize = this.$refs.svg.getBBox();
    this.RoomInstance.updateTargetSize(svgSize.width, svgSize.height);
    this.subPlacement = this.RoomInstance.getSubPositions();
    this.arrows = this.RoomInstance.getArrows();
    this.lines = this.RoomInstance.getLines();
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  methods: {
    renderDistance: function(distance) {
      if (this.unit === "feet")
        return parseFloat((distance * this.feetConst).toFixed(1));

      return distance;
    }
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  computed: {
    getTextStyle() {
      return (line) => ({
          fontFamily: 'Sora',
          fontStyle: 'light',
          fontSize: '15px',
          fill: 'white',
          cursor: 'pointer',
          textAnchor: line.direction === 'vertical' ? 'start' : 'middle'
      });
    }
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  watch: {
    currentWidth: async function() {
      this.subPlacement = this.RoomInstance.getSubPositions();
      this.arrows = this.RoomInstance.getArrows();
      this.lines = this.RoomInstance.getLines();
    },
    //////////////////////////////////////////////////////////////////
    currentHeight: async function() {
      this.subPlacement = this.RoomInstance.getSubPositions();
      this.arrows = this.RoomInstance.getArrows();
      this.lines = this.RoomInstance.getLines();
    }
  }
}
</script>

<style lang="scss" scoped>
  .line-design {
    stroke: $gray;

    .arrow-design {
      fill: $gray;
    }
  }
</style>